import React from 'react';
import { Box, IconButton, keyframes } from '@mui/material';
import { KeyboardArrowDown } from '@mui/icons-material';

const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
`;

interface ScrollDownButtonProps {
  onClick?: () => void;
}

const ScrollDownButton: React.FC<ScrollDownButtonProps> = ({ onClick }) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: 20,
        left: '50%',
        transform: 'translateX(-50%)',
        animation: `${bounce} 2s infinite`,
        cursor: 'pointer',
        zIndex: 2,
      }}
    >
      <IconButton
        onClick={onClick}
        sx={{
          color: 'white',
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
          },
        }}
      >
        <KeyboardArrowDown />
      </IconButton>
    </Box>
  );
};

export default ScrollDownButton; 